module.exports = __webpack_public_path__ + "img/gall-5.ab93fcf1.jpg";